import { useState, type ReactNode } from "react"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { Sidebar as LayoutSidebar } from "@/components/layout/Sidebar"
import { ShellHeader, ShellHeaderProvider } from "@/components/layout/ShellHeader"

interface ToolsLayoutProps {
  children: ReactNode
}

/**
 * Simple layout for Tools pages that includes the sidebar
 * but doesn't require FilterContext or other dashboard-specific providers
 */
export default function ToolsLayout({ children }: ToolsLayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)

  return (
    <SidebarProvider defaultOpen={!isSidebarCollapsed}>
      <ShellHeaderProvider>
      <LayoutSidebar 
        isCollapsed={isSidebarCollapsed} 
        setIsCollapsed={setIsSidebarCollapsed}
      />
      
      <SidebarInset className="flex flex-col min-h-0 min-w-0 h-full overflow-hidden transition-all duration-300">
        <ShellHeader />
        {/* Main Content Area - Scrollable */}
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden bg-surface scrollbar-auto-show">
          {children}
        </div>
      </SidebarInset>
      </ShellHeaderProvider>
    </SidebarProvider>
  )
}


